import { apiRequest } from '../api';

// Admin → Team calendars (server: routes/teamCalendars.ts). Passwords go up, never come back.
export type CalPasswordState = 'none' | 'plain' | 'sealed' | 'unreadable';
export interface TeamCalendar {
  id: string; email: string; label: string; color: string; sortOrder: number; active: boolean;
  passwordState: CalPasswordState; shownAs: string;
}
export interface TeamCalendarInput { email?: string; label?: string; color?: string; password?: string; active?: boolean }

const BASE = '/admin/team-calendars';
export const teamCalApi = {
  list: (): Promise<{ accounts: TeamCalendar[]; defaultColor: string }> => apiRequest('GET', BASE),
  create: (d: TeamCalendarInput): Promise<TeamCalendar> => apiRequest('POST', BASE, d),
  update: (id: string, d: TeamCalendarInput): Promise<TeamCalendar> => apiRequest('PATCH', `${BASE}/${encodeURIComponent(id)}`, d),
  reorder: (ids: string[]): Promise<{ accounts: TeamCalendar[] }> => apiRequest('PUT', `${BASE}/order`, { ids }),
  seal: (): Promise<{ sealed: number; accounts: TeamCalendar[] }> => apiRequest('POST', `${BASE}/seal`, {}),
  test: (id: string): Promise<{ ok: boolean; status: number; calendars: number; error?: string }> =>
    apiRequest('POST', `${BASE}/${encodeURIComponent(id)}/test`, {}),
};
